import { API } from "../../utils/api";
import {
  delteAdminBookingItem,
  delteUserBookingItem,
  getAdminBookingsList,
  getHostRequests,
  getUserBookingsList,
  getUserPaymentsList,
  removeHostRequest,
} from "../Reducers/BookingReducer";

export const getUserBookingsListAction = (data, dispatch) =>
  API.getUserBookings(data).then((res) => {
    if (res.type === "success") {
      dispatch(getUserBookingsList({ items: res.data }));
    }

    return res;
  });

export const deleteUserBookingAction = (data, dispatch) => {
  const bookingId = data.bookingId || data.id;
  return API.deleteUserBooking({ bookingId, id: bookingId }).then((res) => {
    if (res.type === "success") {
      dispatch(delteUserBookingItem({ id: bookingId }));
    }

    return res;
  });
};

export const getAdminBookingsListAction = (data, dispatch) =>
  API.getAdminBookings(data).then((res) => {
    if (res.type === "success") {
      dispatch(getAdminBookingsList({ items: res.data }));
    }

    return res;
  });

export const deleteAdminBookingAction = (data, dispatch) => {
  const bookingId = data.bookingId || data.id;
  return API.deleteAdminBooking({ bookingId, id: bookingId }).then((res) => {
    if (res.type === "success") {
      dispatch(delteAdminBookingItem({ id: bookingId }));
    }

    return res;
  });
};

export const getUserPaymentsListAction = (data, dispatch) =>
  API.getUserPayments(data).then((res) => {
    if (res.type === "success") {
      dispatch(getUserPaymentsList({ items: res.data }));
    }

    return res;
  });

export const getHostRequestsAction = (data, dispatch) =>
  API.getCombinedRequests(data).then((res) => {
    if (res.type === "success") {
      const append = data && data.page && data.page > 1;
      dispatch(getHostRequests({ items: res.data, append }));
    }
    return res;
  });

export const acceptBookingRequestAction = (data, dispatch) =>
  API.acceptBookingRequest(data).then((res) => {
    if (res.type === "success") {
      dispatch(removeHostRequest({ id: data.id }));
    }
    return res;
  });

export const denyBookingRequestAction = (data, dispatch) =>
  API.denyBookingRequest(data).then((res) => {
    if (res.type === "success") {
      dispatch(removeHostRequest({ id: data.id }));
    }
    return res;
  });

export const acceptBookingTimechangeAction = (data, dispatch) =>
  API.acceptBookingTimechange(data).then((res) => {
    if (res.type === "success") {
      dispatch(removeHostRequest({ id: data.timeChangeId }));
    }
    return res;
  });

export const denyBookingTimechangeAction = (data, dispatch) =>
  API.denyBookingTimechange(data).then((res) => {
    if (res.type === "success") {
      dispatch(removeHostRequest({ id: data.timeChangeId }));
    }
    return res;
  });
